import type { User } from '@/types'

/**
 * 与门户 Navbar / 控制台 Topbar 共用的账号展示名。
 * 优先级：displayName → username → email → fallback
 */
export function getUserDisplayName(
  user: Pick<User, 'displayName' | 'username' | 'email'> | null | undefined,
  fallback: string
): string {
  const name =
    user?.displayName?.trim() ||
    user?.username?.trim() ||
    user?.email?.trim() ||
    ''
  return name || fallback
}

export function getUserInitial(user: Pick<User, 'displayName' | 'username' | 'email'> | null | undefined): string {
  const name = getUserDisplayName(user, 'U')
  return name[0]?.toUpperCase() || 'U'
}
